<!-- 提现记录 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex">
        <div class="text">提现记录</div>
      </div>
      <div class="content">
        <el-table
          height="72vh"
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="RecordList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="ID"> </el-table-column>
          <el-table-column prop="bankowner" label="用户名"> </el-table-column>
          <el-table-column prop="withdrawprice" label="金额"> </el-table-column>
          <el-table-column prop="bankname" label="银行" width="210">
          </el-table-column>
          <el-table-column prop="bankcard" label="账号" width="180">
          </el-table-column>
          <el-table-column label="申请时间">
            <template slot-scope="scope">
              {{ scope.row.createtime | filterTime }}
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex" v-if="RecordList !== ''">
          <div class="text">
            <span>共{{ RecordList.total }}条记录，</span>
            <span class="pageNum">{{ RecordList.pageNum }}</span>
            <span>/{{ RecordList.pages }}页</span>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="RecordList.pageNum"
            :page-size="RecordList.pageSize"
            layout="prev, pager, next, jumper"
            :total="RecordList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiWithdrawalRecordList } from '@/api/orderManage'

export default {
  name: '',
  props: [''],
  data() {
    return {
      RecordList: '', // 列表
      pages: {
        page: 1, // 页数
        size: 20
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.WithdrawalRecordList()
  },

  methods: {
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.WithdrawalRecordList()
    },
    // 接口
    // 获取提现记录列表
    WithdrawalRecordList() {
      apiWithdrawalRecordList({
        pageNum: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.RecordList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
</style>
